module.exports = __webpack_public_path__ + "img/test.d0e69649.png";